import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, TemplateRef, SkipSelf, Optional, DoCheck } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, FormGroupDirective, NgForm, NgControl } from '@angular/forms';
import { uuid, getValueByKey, isNullOrEmpty } from '@awp/core/utils';
import { ErrorStateMatcher, CanUpdateErrorStateCtor, mixinErrorState } from '@angular/material/core';

class OptionSelectBase {
  constructor(
    public _defaultErrorStateMatcher: ErrorStateMatcher,
    public _parentForm: NgForm,
    public _parentFormGroup: FormGroupDirective,
    public ngControl: NgControl) { }
}

const _OptionSelectMixinBase: CanUpdateErrorStateCtor = mixinErrorState(OptionSelectBase)

@Component({
  selector: 'ap-option-select',
  templateUrl: './option-select.component.html',
  host: {
    'class': 'ap-option-select',
  },
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OptionSelectComponent,
      multi: true
    },
    {
      provide: ErrorStateMatcher,
      useExisting: OptionSelectComponent
    }
  ]
})
export class OptionSelectComponent extends _OptionSelectMixinBase implements OnInit, OnChanges, ControlValueAccessor, ErrorStateMatcher, DoCheck {

  groupName: string;

  @Input() formControlName: string;
  @Input() robotId: string;
  @Input() selectOption: 'button' | 'button-toggle' | 'radio' | 'dropdown' = 'button-toggle';
  @Input() options: any[] | any = [];
  @Input() value: any;
  @Input() displayName: string;
  @Input() fieldValue: string;
  @Input() disabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() itemTemplate: TemplateRef<any>;
  @Input() placeholder: string;
  @Output() changed = new EventEmitter<any>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    @SkipSelf() private defaultErrorStateMatcher: ErrorStateMatcher,
    @Optional() private _parentFormGroup: FormGroupDirective,
    @Optional() private _parentForm: NgForm) {
    super(defaultErrorStateMatcher, _parentForm, _parentFormGroup);
    this.groupName = uuid();
    this.errorStateMatcher = this;
   }

  errorStateMatcher: ErrorStateMatcher;
  errorState: boolean;

  isErrorState(control: FormControl, form: FormGroupDirective | NgForm): boolean {
    if (control == null && form && this.formControlName && form.control.get(this.formControlName)) {
      this.errorState = form.submitted && form.control.get(this.formControlName).invalid;
      return this.errorState;
    }
    return this.defaultErrorStateMatcher.isErrorState(control, form);
  }

  ngOnInit(): void {}

  ngDoCheck(): void {
    this.updateErrorState();
  }

  ngOnDestroy(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes != null && changes.value != null) {
      this.writeValue(changes.value.currentValue);
    }
  }

  onChange(value: any): void {
    this.value = value;

    if (!isNullOrEmpty(this.fieldValue)
      && (this.selectOption === 'dropdown' || this.selectOption === 'radio')) {
      value = this.options.find(p => getValueByKey(p, this.fieldValue) === value);
    }

    this._onChange(value);
    this.changed.emit(value);
    this._onTouched();
  }


  //#region ControlValueAccessor

  _onTouched = () => { };
  _onChange = (value: any) => {};

  writeValue(value: any): void {
    this.value = value;
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  //#endregion

}
